module.exports = __webpack_public_path__ + "img/h1.2f53d528.jpg";